<script>
  import { createEventDispatcher } from 'svelte';

  export let initialValue = "Click to edit";
  export let validate = (value) => true; 
  export let isTextarea = false; 
  export let editClass = "";  // new
  export let viewClass = "";  // new

  let value = initialValue;
  let isEditing = false;
  let isValid = true;

  const dispatch = createEventDispatcher();

  function handleBlur() {
    if (validate(value)) {
      dispatch('update', value);
      isValid = true;
    } else {
      isValid = false;
    }
    isEditing = false;
  }
</script>

<div class="relative">
  {#if isEditing}
    {#if isTextarea}
      <textarea 
        bind:value 
        class={`border p-1 ${editClass} ${!isValid ? 'invalid' : ''}`} 
        on:blur={handleBlur}
        autofocus
      ></textarea>
    {:else}
      <input 
        bind:value 
        class={`border p-1 ${editClass} ${!isValid ? 'invalid' : ''}`} 
        on:blur={handleBlur}
        autofocus
      />
    {/if}
  {:else}
    <div 
      class={`cursor-pointer p-1 hover:bg-gray-200 ${viewClass} flex justify-start`} class:items-center={!isTextarea}
      on:click={() => (isEditing = true)}
    >
      <div class="h-min">
        {value}
      </div>
    </div>
  {/if}
</div>

<style>
  .invalid {
    border-color: red;
  }
</style>

